<template>
  <div>
    <!-- 标题 -->
    <!-- <div>
      <van-nav-bar title="资讯详情" />
    </div> -->
    <!-- 内容 -->
    <div class="essay">
      <div class="essayTitle" style="font-size: 18px">{{ list.Title }}</div>
      <div class="rikind">{{ list.TkName }}</div>
      <!-- <div v-if="list.ThematicUrl"
        class="essayImg">
        <img :src="list.ThematicUrl"
          alt=""
          @click="thematic(list.ThematicUrl)" />
      </div> -->
      <p
        class="essayContent"
        v-html="list.Content"
        @click="imageEnlargement"
      ></p>
      <div class="video" v-if="list.Video">
        <video style="width: 100%" :src="list.Video" controls="controls">
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div class="rikind" style="">阅读 {{ list.ReadNum }}</div>
      <div class="rikind" style="text-align: right">{{ list.IssTime }}</div>
    </div>
  </div>
</template>
<script>
import { ImagePreview, Toast } from "vant";
import { WeGetRealInfo,addJf } from "@/api/RealInfo";
import { setOpenId, getOpenId } from "@/utils/auth";
import { Dialog } from "vant";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      list: {},
      pdf: "",
      pdfh5: "",
      jfadd:0,

    };
  },
  methods: {
    thematic(e) {
      ImagePreview({
        images: [e], // 传递的是图片集数组
        startPosition: 0, // 图片索引位置
        closeable: true, // 是否显示关了按钮
        showIndicators: true, // 是否显示轮播指示器
        loop: false, // 不设置为false,首图和尾部图不能正常加载
      });
    },
    // 富文本图片内容 点击放大
    imageEnlargement(e) {
      if (e.target.nodeName === "IMG") {
        ImagePreview({
          images: [e.target.src], // 传递的是图片集数组
          startPosition: 0, // 图片索引位置
          closeable: true, // 是否显示关了按钮
          showIndicators: true, // 是否显示轮播指示器
          loop: false, // 不设置为false,首图和尾部图不能正常加载
        });
      }
    },
    getRealInfo() {
      WeGetRealInfo(this.$route.params.Id).then((res) => {
        
        this.list = res.data.data;
        // 调用转发接口
        window.wx.miniProgram.postMessage({
        //wxSdk为微信sdk
      data: {
        shareTitle: '资讯', //自定义
        // shareUrl: 'shareUrl', //自定义
        path: '/trealinfo/detail/' + this.$route.params.Id 
        },
      })

      })
      .then(()=>{
        let userId = getOpenId()
        addJf({
          type:5,//加
          articleId:this.$route.params.Id,
          userId:userId
        })
      })
      // this.activated()
    },

  
  
    
  

    // 经过20秒积分加2
     addIntegral(item,userId){
      addJf({
        type:2,//加
        articleId:item,//文章id
        userId:userId// 用户id
      }).then(res=>{
        console.log(res,1111);
        // this.jfadd=1
        // if(this.jfadd==1){
        //   Dialog.alert({
        //   title: '提示',
        //   message: '积分成功+2!',
        // })
        // }
       
      })

    }
  },
  mounted() {
    this.getRealInfo();
    const item = this.$route.params.Id
    const userId = getOpenId()
    this.timer = setTimeout(()=>{
      this.addIntegral(item,userId)
    },2000)
  },
  destroyed(){
    this.timer =null
  }
};
</script>
<style>
.essay .essayContent img {
  display: block;
  width: 100%;
}
.pageNum-num {
  display: none;
}
.m-pdf img {
  width: 100%;
}
.button {
  width: 95%;
  margin: 15px 2.5%;
}
</style>
